import React from 'react'
import { Card, CardBody, CardHeader, Row } from 'reactstrap'

const MesFestivo = (props) => {

    const daysInMonth = new Date(props.anno,  props.mes+1, 0).getDate();
    const firstDayOfMonth = new Date(props.anno, props.mes, 1).getUTCDay();
    const diasFestivos = props.diasFestivos.map(festivo => festivo.dia);

   
  

    const weeks = [];
    let week = [];

    for (let i = 0; i < firstDayOfMonth; i++) {
      week.push(<div key={`empty-${i}`} className="col"></div>);
    }

    for (let i = 1; i <= daysInMonth; i++) {
      const day = new Date(props.anno, props.mes, i);
      const dayOfWeek = day.getUTCDay();
      const isFestivo = diasFestivos.includes(i);
        week.push(
        <div key={i} className={`col ${isFestivo? "text-danger":""} text-right`} onClick={()=> props.handleSetFestivo(i,isFestivo) } style={{cursor: 'pointer'}}>
          {i<=9 ? "0"+i: i}
        </div>
      );
      if (dayOfWeek === 6 || i === daysInMonth) {
        if (i === daysInMonth && dayOfWeek !== 6) {
            for (let j = dayOfWeek + 1; j <= 6; j++) {
              week.push(<div key={`empty-${j}`} className="col"></div>);
            }
          }
        weeks.push(<div key={weeks.length} className="row no-gutters">{week}</div>);
        week = [];
      }
    }

  return (
    <>
    <Card className="shadow">
              <CardHeader className="bg-transparent">
                <Row className="align-items-center">
                  <div className="col">
                    <h6 className="text-uppercase text-muted ls-1 mb-1">
                      {props.nombreMes} {props.anno}
                    </h6>
                   
                  </div>
                </Row>
              </CardHeader>
              <CardBody>
              <div className="calendar">
          <div className="row no-gutters">
          
            <div className="col text-right">L</div>
            <div className="col text-right">M</div>
            <div className="col text-right">X</div>
            <div className="col text-right">J</div>
            <div className="col text-right">V</div>
            <div className="col text-right">S</div>
            <div className="col text-right">D</div>
          </div>
          {weeks}
        </div>
               
              </CardBody>
            </Card>

    </>
  )
}

export default MesFestivo